// eslint-disable-next-line import/prefer-default-export
export function tooltipTeamPlotHelper(context) {
  const { dataset } = context;
  const dataPoint = dataset.data[context.dataIndex];
  if (Array.isArray(dataPoint)) {
    const lastValue = dataPoint[dataPoint.length - 1];
    if (context.dataset.label) {
      return [context.dataset.label, parseFloat(Number(lastValue).toFixed(2))];
    }
    return [parseFloat(Number(lastValue).toFixed(2))];
  }
  if (context.dataset.label) {
    return [context.dataset.label, parseFloat(Number(context.parsed.y).toFixed(2))];
  }
  return [parseFloat(Number(context.parsed.y).toFixed(2))];
}

export function moodomatToolTipHelper(context, dailyCount) {
  if (Array.isArray(dailyCount)) {
    const count = dailyCount.filter((val) => {
      const d1 = new Date(val.x);
      return (context.parsed.x === d1.getTime());
    });
    const newLabel = `${context.dataset.label} : ${parseFloat(Number(context.parsed.y).toFixed(3))} Moodomat count : ${count[0].y}`;
    return [newLabel];
  }
  return [context.dataset.label, context.parsed.y];
}

export function removeTimeToolTipHelper(context) {
  if (Array.isArray(context)) {
    const dateParts = context[0].label.split(',');
    return [dateParts[0].concat(',').concat(dateParts[1])];
  }
  return [context[0].label];
}

export function generateListColors(counter) {
  const defaultColors = ['#F49718', '#FF0099', '#F501E4', '#8F0085', '#C97E14', '#940059'];
  const colors = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < counter; i++) {
    if (defaultColors?.[i]) colors.push(defaultColors[i]);
    else colors.push(`rgba(244, ${(151 + i * 40) % 256}, ${(24 + i * 80) % 256}, 1)`);
  }
  return colors;
}

export function addMissingColor(colorList, colorSelections) {
  // eslint-disable-next-line no-restricted-syntax
  for (const color of colorList) {
    if (!colorSelections.includes(color)) {
      colorSelections.push(color);
      break;
    }
  }
  return colorSelections;
}
